import { render } from "./IconUser.vue?vue&type=template&id=37c7495a"
import script from "./IconUser.vue?vue&type=script&lang=ts"
export * from "./IconUser.vue?vue&type=script&lang=ts"
script.render = render

export default script